import { Applicant, APPLICANT_KIND } from '@flatsy/types/Applications/Applicant'

const findGuarantor = (id: string, applicants: Applicant[]): Applicant | undefined => {
  const guarantor = applicants.find(
    (el) => el.kind === APPLICANT_KIND.guarantor && el.applicant_id === id
  )
  return guarantor
}

const findMain = (applicants: Applicant[]) => {
  const main = applicants.find((el) => el.kind === APPLICANT_KIND.main)
  const array = []
  if (main) {
    array.push(main)
    const guarantor = findGuarantor(main.id, applicants)
    if (guarantor) {
      array.push(guarantor)
    }
  }
  return array
}
export const OrderApplicants = (applicants: Applicant[]): Applicant[] => {
  const main = findMain(applicants)
  const newApplicants: Applicant[] = [...main]

  applicants.forEach((element) => {
    if (element.kind !== APPLICANT_KIND.guarantor && element.kind !== APPLICANT_KIND.main) {
      newApplicants.push(element)
      const guarantor = findGuarantor(element.id, applicants)
      if (guarantor) {
        newApplicants.push(guarantor)
      }
    }
  })
  return newApplicants
}
